import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import DialogArtistName from 'commons/DialogArtistName';
import FormInput from 'commons/Form/FormInput';
import FormCheckBoxController from 'commons/FormHook/FormCheckBoxController';
import FormInputWithIcons from 'commons/FormInputWithIcons';
import Text from 'commons/Text';
import useDebounce from 'hooks/useDebounce';

import AutocompleteSearchUserWrapper from './components/AutocompleteSearchUserWrapper';
import useStyles from './styles';

const FormUserByRoleCollector = ({
  artworkFormState,
  hasCertificate,
  userFilter,
  handleInputSearchUser,
  handleCheckArtist,
  handleClickPaper,
  handleSelectUser,
  handleSearchAgain,
  handleClickClearIon,
  handleClickSelectSaveUser,
  dialogArtistName,
  isShowCustomPaper,
  titleListUser,
  titleSaveUser,
  roleUser,
  showText = true,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { formState, control, watch, register } = artworkFormState;
  const {
    isShowInputArtistName,
    isShowCheckBoxCustom,
    checkedArtistUnknown,
    selectedUser,
    artistName,
  } = watch();

  const [inputValue, setInputValue] = useState('');
  const debounceInputValue = useDebounce(inputValue);

  return (
    <>
      {selectedUser?.id && (
        <div>
          <FormInputWithIcons
            selectedUser={selectedUser}
            onClickClearIon={handleClickClearIon}
          />
        </div>
      )}

      {!isShowInputArtistName && !selectedUser?.id && (
        <AutocompleteSearchUserWrapper
          userFilter={userFilter}
          handleInputSearchUser={(e) => {
            handleInputSearchUser?.(e);
            setInputValue(e.target.value);
          }}
          handleClickPaper={handleClickPaper}
          handleSelectUser={handleSelectUser}
          handleClickSelectSaveUser={handleClickSelectSaveUser}
          selectedUser={selectedUser}
          checkedArtistUnknown={checkedArtistUnknown || hasCertificate}
          formState={formState}
          isShowCustomPaper={isShowCustomPaper}
          titleListUser={titleListUser}
          titleSaveUser={titleSaveUser}
          roleUser={roleUser}
          inputValue={debounceInputValue}
        />
      )}

      {isShowInputArtistName && !selectedUser?.id && (
        <div>
          <FormInput
            {...register('artistName')}
            disabled
            labelStyle={classes.formInputLabel}
            textFieldStyle={classes.textFieldStyle}
            wrapFormInputStyle={classes.wrapFormInput}
          />
        </div>
      )}

      {(selectedUser?.id || artistName) && !hasCertificate && showText && (
        <Text
          type="sm"
          mt={8}
          onClick={handleSearchAgain}
          className={classes.textSearchAgain}
        >
          <Trans
            i18nKey="want_to_change_name_search_again"
            values={{ search: t('search_again') }}
          />
        </Text>
      )}

      {isShowCheckBoxCustom && (
        <FormCheckBoxController
          name="checkedArtistUnknown"
          control={control}
          onChange={handleCheckArtist}
          error={!!formState?.errors.checked}
          helperText={formState?.errors.checked?.message}
          textCheckBox={t('the_artist_is_unknown')}
          disabled={hasCertificate}
        />
      )}

      <DialogArtistName {...dialogArtistName} />
    </>
  );
};

export default FormUserByRoleCollector;
